import React from 'react';
import { Text, TextInput } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('login.twoFactor.EmailPreActivate');
export default function EmailPreActivate(props) {
  const {
    preActivateData,
    setPreActivateData
  } = props;
  const onChange = ({
    data,
    value
  }) => {
    setPreActivateData({
      ...preActivateData,
      [data]: value
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    variant: "twoStepTitle|title"
  }, t('title')), /*#__PURE__*/React.createElement(Text, null, t('subtitle')), /*#__PURE__*/React.createElement(TextInput, {
    hint: t('hint'),
    value: preActivateData?.email,
    onChange: onChange,
    eventData: "email",
    variant: "formInput",
    changeOnReturn: false
  }));
}